const DeviceList = () =>
    import( /* webpackChunkName: "pages" */ './device-list/index.vue')
const CollectionDetails = () =>
    import( /* webpackChunkName: "pages" */ './collection-details/index.vue')
const UsageDetails = () =>
    import( /* webpackChunkName: "pages" */ './usage-details/index.vue')
const PriceControl = () =>
    import( /* webpackChunkName: "pages" */ './personalSettings/price-control/index.vue')
const PersonalCenter = () =>
    import( /* webpackChunkName: "pages" */ './personalSettings/personal-center/index.vue')
const MessageRecord = () =>
    import( /* webpackChunkName: "pages" */ './personalSettings/message-record/index.vue')
const HistoryData = () =>
    import(/* webpackChunkName: "pages" */ './historyData/main.vue')

//菜单级页面
export const routes = [
    {
        path: '/deviceList',
        name: 'DeviceList',
        meta: { title: 'lang.设备列表' },
        component: DeviceList,
    },
    {
        path: '/historyData',
        name: "HistoryData",
        meta: { title: "lang.历史数据" },
        component: HistoryData
    },
    {
        path: '/collectionDetails',
        name: 'CollectionDetails',
        meta: { title: 'lang.收款明细' },
        component: CollectionDetails,
    },
    {
        path: '/usageDetails',
        name: 'UsageDetails',
        meta: { title: 'lang.使用明细' },
        component: UsageDetails,
    },
    {
        path: '/priceControl',
        name: 'PriceControl',
        meta: { title: 'lang.价格管理' },
        component: PriceControl,
    },
    {
        path: '/personalCenter',
        name: 'PersonalCenter',
        meta: { title: 'lang.个人中心' },
        component: PersonalCenter,
    },
    {
        path: '/messageRecord',
        name: 'MessageRecord',
        meta: { title: 'lang.消息记录' },
        component: MessageRecord,
    },
]